export default function getPermissionLabels(
  permissions = [],
  allPermissions = []
) {
  const elements = [];

  for (const perm of permissions) {
    if (!perm || !perm.resource || !Array.isArray(perm.actions)) continue;

    const resourceInfo = allPermissions.find(
      (p) => p && p.resource === perm.resource
    );
    if (
      !resourceInfo ||
      !resourceInfo.label ||
      !Array.isArray(resourceInfo.actions)
    )
      continue;

    const resourceLabel = resourceInfo.label;

    const actionLabels = perm.actions
      .map((actionKey) => {
        const actionInfo = resourceInfo.actions.find(
          (a) => a && a.key === actionKey
        );
        return actionInfo && actionInfo.label ? actionInfo.label : null;
      })
      .filter(Boolean);

    if (actionLabels.length > 0) {
      elements.push(
        <span
          key={perm.resource}
          className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full inline-block m-0.5"
        >
          {resourceLabel}: {actionLabels.join(" - ")}
        </span>
      );
    }
  }

  return elements;
}
